import { API } from "./apiAuth";
let whileFetching = false;
let abortController;
let abortControllers = [];
// 모든 요청 취소 함수
const cancelAllRequests = () => {
  abortControllers.forEach(controller => controller.abort());
  abortControllers = []; // 배열 초기화
};

// 월 수익율 pdf download api
const getProfitMonthApi = async (exchange, year_month) => {
  try {
    const response = await API.get(
      `monthly-profit-report?year_month=${year_month}&exchange=${exchange}`
    );
    return response.data;
  } catch (error) {
    return;
  }
};
// 월 수익율 pdf download api
const getProfitPdfApi = async (year_month) => {
  try {
    const response = await API.get(
      `monthly-profit/pdf?year_month=${year_month}`
    );
    return response;
  } catch (error) {
    return;
  }
};
// 월 수익율 excel download api
const getProfitExcelApi = async (year_month) => {
  try {
    const response = await API.get(
      `monthly-profit/excel-xls?year_month=${year_month}`,
      { responseType: "blob" }
    );
    return response;
  } catch (error) {
    return;
  }
};
// 주간 수익율 pdf download api
const getWeekProfitPdfApi = async (year_week) => {
  try {
    const response = await API.get(`weekly-profit/pdf?year_week=${year_week}`);
    return response;
  } catch (error) {
    return;
  }
};
// 주간 수익율 excel download api
const getWeekProfitExcelApi = async (year_week) => {
  try {
    const response = await API.get(
      `weekly-profit/excel-xls?year_week=${year_week}`,
      { responseType: "blob" }
    );
    return response;
  } catch (error) {
    return;
  }
};
// 일일 결산 조회 api
const getDailyProfitApi = async (info, page) => {
  try {
    if (info.start_date == "" && info.end_date == "") {
      const response = await API.get(
        `daily-profit-report?page=${page}&per_page=${info.per_page}&exchange=${info.exchange}`
      );
      return response.data;
    } else {
      const response = await API.get(
        `daily-profit-report?page=${page}&per_page=${info.per_page}&exchange=${info.exchange}&start_date=${info.start_date}&end_date=${info.end_date}`
      );
      return response.data;
    }
  } catch (error) {
    return;
  }
};
// 거래소별 주간 수익률 조회 api
const getWeekExchangeApi = async (exchange) => {
  try {
    const response = await API.get(`weekly-profit-report?exchange=${exchange}`);
    return response.data;
  } catch (error) {
    return;
  }
};
// 결산 내역 조회 api
const getMonthLogApi = async (info, page) => {
  try {
    if (whileFetching) abortController.abort();
    abortController = new AbortController();
    const signal = abortController.signal;
    whileFetching = true;
    const response = await API.post(
      `month-profits?page=${page}&size=${info.size}&date=${info.date}&profit_type=${info.type}`,
      { signal }
    );
    whileFetching = false;
    return response.data;
  } catch (error) {
    return;
  }
};
// 월말 결산 & 주간 결산 조회 api
const getUserProfitApi = async (info, page) => {
  try {
    const response = await API.get(
      `user-profits?page=${page}&size=${info.size}&retri_id=${info.retri_id}&date=${info.date}&exc=${info.exchange}&profit_type=${info.type}&uid=${info.uid}`
    );
    return response.data;
  } catch (error) {
    return;
  }
};

// 누적 결산 조회 api
const getTotalProfitApi = async (info, page) => {
  const abortController = new AbortController();
  const signal = abortController.signal;
  try {
    cancelAllRequests();
    abortControllers.push(abortController);
    let response;
    if(info.status == ""){
      response = await API.get(
        `retri-profits?page=${page}&size=${info.size}&retri_id=${info.retri_id}&date=${info.date}&exc=${info.exchange}&uid=${info.uid}`
      ,{ signal });
    }else{
      response = await API.get(
        `retri-profits?page=${page}&size=${info.size}&retri_id=${info.retri_id}&date=${info.date}&exc=${info.exchange}&uid=${info.uid}&status=${info.status}`
      ,{ signal });
    }
    abortControllers = abortControllers.filter(ctrl => ctrl !== abortController);

    return response.data;
  } catch (error) {
    abortControllers = abortControllers.filter(ctrl => ctrl !== abortController);
    return { message : error.message};
  }
};
// 주간결산 보내기 / 리트리 api
const getWeekIncomeApi = async (admin) => {
  try {
    const response = await API.post(
      `month-income?admin=${admin}&profit_type=0`
    );
    return response;
  } catch (error) {
    return error.response;
  }
};
/// 주간결산 보내기 전 내역 확인/ 리트리 api
const checkIncomeRetri = async () => {
  try {
    const response = await API.get(
      `check_week_closing`
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};
export default {
  getProfitPdfApi,
  getProfitExcelApi,
  getWeekProfitPdfApi,
  getWeekProfitExcelApi,
  getMonthLogApi,
  getUserProfitApi,
  getProfitMonthApi,
  getDailyProfitApi,
  getWeekExchangeApi,
  getWeekIncomeApi,
  getTotalProfitApi,
  checkIncomeRetri
};
